import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
//import { IconName } from '@fortawesome/fontawesome-svg-core';
import { DynamicObjectInterface } from '../../../../sdk/type';
import { useAPICall } from '../../../../hooks';
import {
  Button,
  ButtonPropsTypes,
  ButtonSize,
  ButtonStyles,
  Card,
  DetailCardProgress,
  HeaderStyle,
  Tag,
  TagStyle,
  Theme,
  IconStyle,
  ButtonIconPosition,
  Modal,
  TextAlign,
  ButtonTypes,
  //SearchComponent,
  Input,
  InputTypes,
  FAIcon,
  MLPVersion,
  Checkbox,
  useBreakpoint,
} from '../../../../ui/components';
//import { InputIconPosition } from '../../../../ui/components/Form/Input/types/enums';
import ShareDrawer from '../../../../ui/components/DrawerAlt/ShareDrawer';
import ParticipantService from '../../../../sdk/services/participantService';
import CoachService from '../../../../sdk/services/coachService';
import TeamService from '../../../../sdk/services/teamService';
import { useAdminToast } from '../../../../ui/components/AdminToast/AdminToast';
import { UserData } from '../../dashboardConfig';
import { formatDateDMYYYY, LoggerService, PAGES, trackPage } from '../../../../ui/utils';
import { MenuDataType } from '../../../home/Home';
import AttachmentService from '../../../../sdk/services/attachmentService';
import { HeaderFlex } from '../../../../ui/components/Form/Card/types/enums';
import { InputValidations } from '../../../../ui/components/Form/SearchComponent/types/propTypes';
import LayerSquarePlus from '../../../../assets/image/icons/layer_square_plus.svg';
import styles from './index.module.scss';
interface TeamDetailsPropsType {
  index: number;
  decodedData: DynamicObjectInterface;
  dataCampaign: MenuDataType;
  role: 'LEADER' | 'COACH' | 'PARTICIPANT';
  myTeamId?: string;
}

export const TeamDetails = (props: TeamDetailsPropsType) => {
  const { dataCampaign, decodedData, myTeamId } = props;
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const apiCall = useAPICall();
  const { adminToast } = useAdminToast();
  const viewPortType = useBreakpoint();
  const isDesktopView = ['xs', 'sm', 'md'].indexOf(viewPortType) === -1;
  const [data, setData] = useState<UserData | null>(null);
  //  const [isParticipant, setIsParticipant] = useState(false);
  // const [isCoach, setIsCoach] = useState(false);
  // const [isLeader, setIsLeader] = useState(false);
  const [profileImageUrls, setProfileImageUrls] = useState<Record<string, string | undefined>>({});
  const [coachName, setCoachName] = useState<string>('');
  const [coachInvalid, setCoachInvalid] = useState(false);
  const [showCoachList, setShowCoachList] = useState(false);
  const [showShareDrawer, setShowShareDrawer] = useState(false);
  const [joinTeamLink, setJoinTeamLink] = useState<string>('');
  const [campaignRecId, setCampaignRecId] = useState(null);
  const [formData, setFormData] = useState<UserData | null>(JSON.parse(JSON.stringify(data)) as UserData);

  // const [masterList, setMasterList] = useState<{
  //   coachList: DynamicObjectInterface;
  // }>();
  //const [filteredCoachList, setFilteredCoachList] = useState(masterList?.coachList);
  const paths = location.pathname.split('/');
  const teamsIdx = paths.indexOf('teams');

  let campaignId = '';
  let teamId = '';
  let currentTeamId =
    dataCampaign.enrollment.find(enrollment => enrollment.enrollmentType === 'PARTICIPANT')?.teamId || '';

  if (teamsIdx !== -1 && teamsIdx + 1 < paths.length) {
    campaignId = decodeURIComponent(paths[teamsIdx - 1]);
    teamId = decodeURIComponent(paths[teamsIdx + 1]);
  }

  if (myTeamId) {
    const myTeamsIdx = paths.indexOf('myTeam');
    campaignId = decodeURIComponent(paths[myTeamsIdx - 1]);
    teamId = myTeamId;
  }

  const today: Date = new Date();
  const teamStartDate: Date | null = data?.teamStartDate ? new Date(data.teamStartDate) : null;

  // Check if the teamStartDate is valid and calculate days since teamStartDate
  const isValidTeamStartDate = teamStartDate && !isNaN(teamStartDate.getTime());
  const daysSinceTeamStart = isValidTeamStartDate
    ? (today.getTime() - teamStartDate.getTime()) / (1000 * 60 * 60 * 24) // getTime() returns the time in milliseconds
    : null;

  const hideButton = isValidTeamStartDate && daysSinceTeamStart !== null && daysSinceTeamStart > 7;

  // useEffect(() => {
  //   (async () => {
  //     let apiList = [apiCall(CoachService.getCoachList)];
  //     let res = await Promise.all(apiList);

  //     let coachData = res?.[0]?.data;

  //     let masterList = {
  //       coachList: [
  //         ...(coachData?.data || []).map((d: DynamicObjectInterface) => ({
  //           ...d,
  //           id: d.coachID,
  //           title: `${d.coachID} - ${d.name}`,
  //         })),
  //       ],
  //     };
  //     setMasterList(masterList);
  //   })();
  // }, []);

  const fetchData = async () => {
    let teamData = await apiCall(ParticipantService.getTeamParticipants, {
      campaignId: campaignId,
      teamId: teamId,
    });

    let participantData = await Promise.all(
      teamData?.data?.data.map(async (teamItem: DynamicObjectInterface) => {
        let participant = await apiCall(
          ParticipantService.getParticipantDetail,
          { campaignId: campaignId, teamId: teamId },
          teamItem.userId.toString(),
        );
        return participant?.data?.data;
      }),
    );
    let campaignData = await apiCall(TeamService.getTeamDetails, `${teamId}`);
    setCampaignRecId(campaignData?.data?.data.campaignRecId);
    setData((i: DynamicObjectInterface) => {
      i = i || {};

      i.isCoachEnrollment = dataCampaign?.enrollment.some(
        (i: DynamicObjectInterface) => i.enrollmentType === 'COACH' || i.enrollmentType === 'LEADER',
      );
      i.teamStartDate = teamData?.data?.data[0]?.teamDetail?.teamStartDate ?? campaignData?.data?.data?.teamStartDate;
      i.teamEndDate = teamData?.data?.data[0]?.teamDetail?.teamEndDate ?? campaignData?.data?.data?.teamEndDate;
      i.participantDetails = teamData?.data?.data;
      // if (role === 'COACH') {
      //   participantData.forEach((participant: DynamicObjectInterface, index: number) => {
      //     if (participant) {
      //       let participantToUpdate = i.participantDetails[index];
      //       let productPoints = (participant.point?.purchase ?? 0) + (participant.point?.purchaseAdj ?? 0);
      //       let resultPoints = (participant.point?.winning ?? 0) + (participant.point?.winningAdj ?? 0);
      //       let subscribePoints = (participant.point?.subscribe ?? 0) + (participant.point?.subscribeAdj ?? 0);
      //       let totalPoints = productPoints + resultPoints + subscribePoints;

      //       participantToUpdate.points = {
      //         product: productPoints,
      //         result: resultPoints,
      //         subscribe: subscribePoints,
      //         totalPoints: totalPoints,
      //       };
      //     }
      //   });
      // }
      i.teamLeader = teamData?.data?.data[0]?.teamDetail?.teamLeader;
      i.teamSize = campaignData?.data?.data?.teamSize;
      i.teamName = teamData?.data?.data[0]?.teamDetail.teamName ?? campaignData?.data?.data?.teamName;
      i.teamCoachId = teamData?.data?.data[0]?.teamDetail?.coachId ?? campaignData?.data?.data?.coachId;
      i.teamCoachName = teamData?.data?.data[0]?.teamDetail?.coachName ?? campaignData?.data?.data?.coachName;
      i.teamDescription = teamData?.data?.data[0]?.teamDetail?.teamDescription;
      // i.teamLeaderLoginId = teamData?.data?.data[0]?.teamDetail?.teamLeaderLoginId;
      i.teamLeaderLoginId = participantData[0]?.team?.teamLeaderUserId;
      i.teamStatus = campaignData?.data?.data?.status;
      i.isIndividualTeam = campaignData?.data?.data?.isIndividualTeam;
      i.campaignRecId = campaignData?.data?.data.campaignRecId;
      i.isMeasured = campaignData?.data?.data.isMeasured;

      return { ...i };
    });
  };

  useEffect(() => {
    // setIsParticipant(false);
    // setIsCoach(false);
    // setIsLeader(false);
    // dataCampaign?.enrollment.forEach(enrollment => {
    //   // switch (enrollment?.enrollmentType) {
    //   // case 'PARTICIPANT':
    //   //   setIsParticipant(true);
    //   //   break;
    //   // case 'COACH':
    //   //   setIsCoach(true);
    //   //   break;
    //   // case 'LEADER':
    //   //   setIsLeader(true);
    //   //   break;
    //   //  }
    //   if (enrollment?.enrollmentType === 'COACH') {
    //     setIsCoach(true);
    //   }
    // });
    fetchData();

    const timeout = setTimeout(() => {
      trackPage(PAGES.teamDetails);
    }, 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, [location]);

  // const goBack = () => {
  //   let idx = location.pathname.indexOf('/teams');
  //   if (idx !== -1) {
  //     let url = location.pathname.substring(0, idx + '/teams'.length);
  //     navigate(url);
  //   }
  // };

  const getButtonConfig = useMemo(() => {
    if (!campaignRecId) return null;

    return {
      addParticipant: [
        {
          title: t('admin.teamEdit.addParticipant'),
          buttonStyle: ButtonStyles.SOLID,
          theme: Theme.BLACK,
          size: isDesktopView ? ButtonSize.SMALL : ButtonSize.EXTRA_SMALL,
          onClick: () => {
            navigate(`/campaigns/teams/add-participant?=${teamId}`);
          },
        },
        {
          title: t('admin.teams.share'),
          buttonStyle: ButtonStyles.OUTLINE,
          icon: { iconName: 'share-alt', iconStyle: IconStyle.SOLID },
          iconPosition: ButtonIconPosition.LEFT,
          theme: Theme.BLACK,
          size: isDesktopView ? ButtonSize.SMALL : ButtonSize.EXTRA_SMALL,
          onClick: () => {
            generateJoinTeamLink();
          },
        },
      ],
    } as { [index: string]: ButtonPropsTypes[] };
  }, [campaignRecId]);

  const fetchProfileImage = async (userId: number) => {
    try {
      const response = await AttachmentService.downloadProfileImage(userId ?? '');
      if (response.data && response.data.data && response.data.data.image) {
        setProfileImageUrls(prevState => ({
          ...prevState,
          [userId]: response.data.data.image,
        }));
      }
    } catch (error) {
      LoggerService.log('Error downloading image', error);
    }
  };

  useEffect(() => {
    data?.participantDetails?.forEach(participant => {
      fetchProfileImage(participant.userId);
    });
  }, [data?.participantDetails]);

  const onSaveCoach = async () => {
    if (teamId) {
      let payload = {
        teamId: teamId,
        teamName: data?.teamName,
        description: data?.teamDescription,
        teamLeader: data?.teamLeaderLoginId,
        coachId: formData?.teamCoachId,
        isIndividualTeam: data?.isIndividualTeam,
        teamStartDate: data?.teamStartDate,
        teamEndDate: data?.teamEndDate,
        status: data?.teamStatus,
      };

      const result = await apiCall(TeamService.updateTeamCoach, teamId, payload);

      if (result.status === 200) {
        adminToast({
          message: t('admin.participant.updateSuccess'),
          theme: Theme.SUCCESS,
        });
        fetchData();
        setShowCoachList(false);
      } else {
        adminToast({
          message: t('admin.participant.updateFail'),
          theme: Theme.ERROR,
        });
      }
    }
  };

  // const searchCoach = (input: string) => {
  //   if (!input) {
  //     setFilteredCoachList(masterList?.coachList);
  //   } else {
  //     const filteredUsers = masterList?.coachList.filter((coach: DynamicObjectInterface) => {
  //       return coach.title.toLowerCase().includes(input.toLowerCase());
  //     });
  //     setFilteredCoachList(filteredUsers);
  //   }
  // };

  const generateJoinTeamLink = () => {
    if (teamId && campaignRecId) {
      const params = `${campaignRecId},${teamId},0`;
      const encodedParam = btoa(params);
      setJoinTeamLink(`${window.location.protocol}//${window.location.host}?source=email&t=${encodedParam}`);
      setShowShareDrawer(true);
    }
  };

  const handleOnChange = async (value: DynamicObjectInterface, key: keyof UserData, ...paths: string[]) => {
    if (key === 'teamCoachId') {
      if (value.length === 10) {
        try {
          const response = await apiCall(CoachService.getNameByCoachId, campaignId, value);
          if (response?.data?.data?.coachName) {
            setCoachName(response.data.data.coachName);
            setCoachInvalid(false);
          } else {
            setCoachInvalid(true);
            setCoachName('');
          }
        } catch (error) {
          setCoachName('');
          setCoachInvalid(true);
        }
      } else {
        setCoachInvalid(value.length !== 0);
        setCoachName('');
      }
    }

    setFormData(prev => {
      if (key === 'teamCoachId') {
        if (prev?.teamCoachId !== value) {
          return { ...(prev as UserData), [key]: value };
        } else {
          return prev;
        }
      } else {
        if (key === 'coachCheck' && prev?.coachCheck === 'on') {
          return { ...(prev as UserData), [key]: '' };
        } else {
          if (!prev) return { ...prev! };

          const setDeep = (obj: DynamicObjectInterface, i = 0) => {
            if (paths.length !== i) {
              let path = i === 0 ? key : paths[i];
              let _obj = obj[path];
              if (_obj) obj = { ...obj, [path]: setDeep(_obj, i + 1) };
            } else {
              obj[paths[i - 1]] = value;
            }
            return obj;
          };

          if (paths.length > 0) {
            return setDeep(data) as UserData;
          } else {
            return { ...prev, [key]: value };
          }
        }
      }
    });
  };

  const coachSelectionPrompt = (
    <>
      {showCoachList && (
        <Modal
          primaryButtonLabel={''}
          headline={'Add Coach'}
          closeIcon={false}
          containerWidth="550px"
          textAlign={TextAlign.LEFT}
          primaryButton={
            <Button
              title="Confirm"
              type={ButtonTypes.BUTTON}
              onClick={() => {
                onSaveCoach();
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.SOLID}
              data-testid="test-add-button-popup"
              disabled={!(formData?.teamCoachId && formData?.coachCheck === 'on') || coachInvalid}
            />
          }
          secondaryButton={
            <Button
              title="Cancel"
              type={ButtonTypes.BUTTON}
              onClick={() => {
                setFormData(data);
                setShowCoachList(false);
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.OUTLINE}
              data-testid="test-cancel-button-popup-delete-modal"
            />
          }
        >
          <>
            <div
              style={{
                fontSize: '16px',
                fontFamily: 'GT-Walsheim-Pro-Bold, sans-serif',
                lineHeight: '24px',
                margin: '10px 0',
              }}
            ></div>

            <div className={styles['search-coach-container']}>
              {/* <SearchComponent
                label={t('admin.teams.coachId')}
                placeholder={t('admin.teams.searchCoach')}
                initialSearchText={
                  masterList?.coachList.find((c: DynamicObjectInterface) => c.id === data?.teamCoachId)?.title
                }
                status={InputValidations.DEFAULT}
                labelChoice={'title'}
                dropdownOptions={filteredCoachList}
                onSearch={searchCoach}
                onClear={() => {
                  searchCoach('');
                  handleOnChange('', 'teamCoachId');
                }}
                onSelect={e => {
                  handleOnChange(e.id, 'teamCoachId');
                }}
              /> */}
              <Input
                key={'team_add_coach'}
                type={InputTypes.TEXT}
                name={'coachId'}
                placeholder={t('admin.teams.searchCoach')}
                label={`${t('admin.teams.coachId')}`}
                // inputIcon={{ iconName: 'close' }}
                // inputIconPosition= {InputIconPosition.RIGHT}
                value={coachName ? coachName : formData?.teamCoachId ? formData?.teamCoachId : ''}
                mlpVersion={MLPVersion.ONE}
                onChange={e => {
                  handleOnChange(e.target.value, 'teamCoachId');
                }}
                status={
                  coachInvalid
                    ? InputValidations.INVALID
                    : coachName.length > 0
                      ? InputValidations.VALID
                      : InputValidations.DEFAULT
                }
                message={coachInvalid ? `${t('admin.teamCreate.invalidCoachId')}` : ''}
              />
              {formData && formData.teamCoachId && formData.teamCoachId.length > 0 && (
                <FAIcon
                  className={styles['close-icon']}
                  iconStyle={IconStyle.SOLID}
                  data-testid="close-icon-test-id"
                  iconName={'close'}
                  theme={Theme.BLACK}
                  onClick={() => {
                    handleOnChange('', 'teamCoachId');
                  }}
                />
              )}
            </div>
            <div style={{ display: 'flex', margin: '32px 0' }}>
              <Checkbox
                key={'checkbox'}
                className={styles['checkbox']}
                checked={formData?.coachCheck === 'on'}
                theme={Theme.BLACK}
                text={
                  <p
                    id="agree-checkbox"
                    dangerouslySetInnerHTML={{
                      __html: t('admin.teamCreate.termsLine1').replace(
                        '{terms-conditions}',
                        `<a href="/terms-and-conditions?cid=${campaignId}" target="_blank">${t('securityPrivacy.terms-condition')}</a>`,
                      ),
                    }}
                  />
                }
                onChange={e => handleOnChange(e.target.value, 'coachCheck')}
              />
              <>
                {/* {t('admin.teamCreate.termsLine1')} */}
                <br />
                {/* {t('admin.teamCreate.termsLine2')} */}
              </>
            </div>
          </>
        </Modal>
      )}
    </>
  );

  const sharePrompt = (
    <>
      {showShareDrawer && (
        <ShareDrawer
          open={!!joinTeamLink}
          onClose={() => setShowShareDrawer(false)}
          title="Share Via"
          programMessage={`You have been invited to join ${dataCampaign?.campaignName} at ${joinTeamLink}`}
          programUrl={joinTeamLink}
          channels={['FaWhatsapp', 'FaLink']}
          programTitle=""
        />
      )}
    </>
  );

  return (
    <div className={styles['team-detail-container']}>
      <Card
        title={t('admin.dashboard.teamDetails')}
        headerStyle={isDesktopView ? HeaderStyle.HEADER_5 : HeaderStyle.HEADER_6}
        headerFlex={isDesktopView ? HeaderFlex.START : undefined}
        button={
          data &&
          data.participantDetails &&
          ((data.participantDetails.filter(participant => participant.status === 'ACTIVE').length <
            Number(data?.teamSize) &&
            data?.isIndividualTeam !== 1) ||
            (data.participantDetails.filter(participant => participant.status === 'ACTIVE').length < 1 &&
              data.isIndividualTeam === 1)) && //AHWP-1470
          ((data.isMeasured === 1 && !hideButton) || data.isMeasured !== 1)
            ? // && (decodedData.name === data.teamLeader || isCoach)  AHWP-1469
              getButtonConfig?.addParticipant
            : undefined
        }
      >
        <div className={styles['team-details-container']}>
          <div className={styles['team-details-title-container']}>
            <div className={styles['team-details-coach']}>
              <Tag text={`${dataCampaign?.campaignName}`} theme={Theme.GRAY} style={TagStyle.SOLID} />
            </div>
            {/* <div className={styles['team-details-coach']}>
              {data?.teamStatus && (
                <Tag
                  text={data?.teamStatus ?? ''}
                  theme={data?.teamStatus === 'ACTIVE' ? Theme.SUCCESS : Theme.PURPLE}
                  style={TagStyle.OUTLINE}
                />
              )}
            </div> */}
            {/* {
              data &&
              data.participantDetails &&
              data.participantDetails.filter((participant) => participant.status === 'ACTIVE').length <
                Number(data?.teamSize) &&
              (decodedData.name === data.teamLeader || decodedData.loginId === data.teamCoachId) && (
                <div className={styles['team-details-add-participant']}>
                  <Button
                    title="+ add participant"
                    theme={Theme.PURPLE}
                    onClick={() => {
                      navigate(`/campaigns/teams/add-participant?=${teamId}`);
                    }}
                    buttonStyle={ButtonStyles.OUTLINE}
                    size={ButtonSize.SMALL}
                  />
                </div>
              )} */}
          </div>
          <div className={styles['team-details-title-container']}>
            <div className={styles['team-details-coach']}>
              <div className={styles['team-details-label']}>{'Team:'}</div>
              <div className={styles['team-details-date-range']}>{data?.teamName}</div>
            </div>
          </div>
          <div className={styles['team-details-title-container']}>
            <div className={styles['team-details-coach']}>
              <div className={styles['team-details-label']}>{'Period:'}</div>
              <div className={styles['team-details-date-range']}>
                {`${data?.teamStartDate ? formatDateDMYYYY(new Date(data?.teamStartDate)) : 'N/A'} - ${
                  data?.teamEndDate ? formatDateDMYYYY(new Date(data?.teamEndDate)) : 'N/A'
                }`}
              </div>
            </div>

            {isDesktopView && (
              <div className={styles['team-details-add-coach']}>
                {data?.teamCoachId ? (
                  <div className={styles['team-details-date-range']}>
                    {`${data?.teamCoachId} - ${data?.teamCoachName}`}
                  </div>
                ) : (
                  <div className={styles['team-details-add-coach']}>
                    <button className={styles['alp-button']} onClick={() => setShowCoachList(true)}>
                      <img className={styles['square-icon']} src={LayerSquarePlus} alt="plus" />
                      <p className={styles['invoice-text']}>{'Add Coach'}</p>
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>

          {!isDesktopView && (
            <div className={styles['team-details-title-container']}>
              <div className={styles['team-details-coach']}>
                <div className={styles['team-details-label']}>{'Coach:'}</div>
                {data?.teamCoachId && data?.teamCoachName ? (
                  <div
                    className={styles['team-details-date-range']}
                  >{`${data?.teamCoachId} - ${data?.teamCoachName}`}</div>
                ) : (
                  <div className={styles['team-details-add-coach']}>
                    <button className={styles['alp-button']} onClick={() => setShowCoachList(true)}>
                      <img className={styles['square-icon']} src={LayerSquarePlus} alt={'plus'} />
                      <p className={styles['invoice-text']}>{'Add Coach'}</p>
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}

          <div>
            {data &&
              data.participantDetails &&
              data.participantDetails.filter(participant => participant.status === 'ACTIVE').length > 0 &&
              data?.participantDetails
                ?.filter(participant => participant.status === 'ACTIVE') // Filter out inactive participants
                .map((participant, index) => (
                  <div key={index} className={styles['team-details-progress-card']}>
                    <DetailCardProgress
                      coachEnrollmentDate={data?.coachEnrollmentDate}
                      isCoachEnrollment={data?.isCoachEnrollment}
                      showCoachDetail={false}
                      showFiveProgress={false}
                      //points={data?.points}
                      profileImageUrl={profileImageUrls[participant.userId]}
                      {...participant}
                      handleRedirect={() =>
                        decodedData.userId === participant.userId && parseInt(currentTeamId) === parseInt(teamId)
                          ? navigate(`/campaigns/${campaignId}`)
                          : myTeamId
                            ? navigate(`user?id=${participant.userId}&tId=${myTeamId}`)
                            : navigate(`user?id=${participant.userId}`)
                      }
                    />
                  </div>
                ))}
          </div>
        </div>
        {coachSelectionPrompt}
        {sharePrompt}
      </Card>
      {/* {!isDesktopView &&
        data &&
        data.participantDetails &&
        data.participantDetails.filter((participant) => participant.status === 'ACTIVE').length <
          Number(data?.teamSize) &&
        (decodedData.name === data.teamLeader || decodedData.loginId === data.teamCoachId) && (
          <div className={styles['team-details-add-participant']}>
            <Button
              title="+ add participant"
              theme={Theme.PURPLE}
              onClick={() => {
                navigate(`/campaigns/teams/add-participant?=${teamId}`);
              }}
              buttonStyle={ButtonStyles.SOLID}
              size={ButtonSize.SMALL}
            />
          </div>
        )} */}
    </div>
  );
};
